export * from "./formatBytes";
export * from "./formatDate";
export * from "../hooks/useDetermineImageClass";

export function isAutodeskAsset(asset: Asset): boolean {
  return !!(asset.media.type === "File" && asset.media.autodeskUrn);
}

export function isAssetSharedAsOriginal(assetDownloadUrl: string): boolean {
  const originalAssetRegexPattern = /\b(\/\w*Original\w*\/)\b/;
  return originalAssetRegexPattern.test(assetDownloadUrl);
}

export function generateTooltipContent(sharedRenditionFileExtension: string | undefined, sharedRenditionWidth: number | undefined, sharedRenditionHeight: number | undefined, sharedRenditionFileSize: string | undefined) {

  const getSharedRenditionDimensionsText = (width?: number, height?: number) => {
    if (width && height) {
      return `${width} x ${height} pixels`
    } else {
      return null;
    }
  }

  const getSharedRenditionFileSize = (fileSize?: string) => {
    if (fileSize) {
      return fileSize;
    }
    return null;
  }

  return [
    sharedRenditionFileExtension?.toUpperCase(),
    getSharedRenditionDimensionsText(sharedRenditionWidth, sharedRenditionHeight),
    getSharedRenditionFileSize(sharedRenditionFileSize)
  ].filter(Boolean);
};

